import $ from 'jquery';

const $selectedCompetencesInput = $('input[name="selected_competences_json"]');
const $competenceBoxes = $('.js-competence-box');
const isDashboard = window.location.href.includes('dashboard');
const isCompetenceEdit = window.location.href.includes(
	'dashboard/my-competences'
);
const placeHolder = $('.js-competence-box a.stretched-link')
	.parents('.js-competence-box')
	.html();
const renderedCompetences = {};
const rerenderCompetences = function (currentCompetences, skipAnimations) {
	skipAnimations = skipAnimations || false;
	// draw current
	currentCompetences.map(async (competenceId, index) => {
		const isLast = currentCompetences.length - 1 === index;
		const startFirstMessageButton = $('.js-undisable-if-competence');
		startFirstMessageButton.attr('disabled', false);
		startFirstMessageButton.addClass('pulse');

		if (currentCompetences.length <= index || competenceId === undefined)
			return $($competenceBoxes[index]).html('');

		if (renderedCompetences[competenceId] === undefined)
			renderedCompetences[competenceId] = await $.ajax(
				'/competence-card/xhr/' + competenceId
			);

		$competenceBoxes[index] = $($competenceBoxes[index]).attr(
			'class',
			'js-competence-box flex-grow-1 h-100' +
				(!skipAnimations && isLast ? ' anim-fade-in' : '')
		);
		$($competenceBoxes[index]).html(renderedCompetences[competenceId]);

		if (!skipAnimations && isCompetenceEdit) {
			$('html, body').animate({ scrollTop: 0 }, 'fast');
		}

		// set edit buttons
		setTimeout(() => {
			$('.js-competence-shift-left')
				.removeClass('btn-outline-gray')
				.attr('disabled', false)
				.first()
				.addClass('btn-outline-gray')
				.attr('disabled', true);

			$('.js-competence-shift-right')
				.removeClass('btn-outline-gray')
				.attr('disabled', false)
				.last()
				.addClass('btn-outline-gray')
				.attr('disabled', true);
		}, 0);
		setTimeout(() => {
			if (window.swipers[0]) window.swipers[0].slideTo(index - 2);
		}, 333);
	});

	// clear the remainder
	for (let i = currentCompetences.length; i < $competenceBoxes.length; i++) {
		if (i === currentCompetences.length)
			$($competenceBoxes[i]).html(placeHolder);
		else $($competenceBoxes[i]).html('');
	}
};

const competenceAction = function (e, action, self) {
	e.preventDefault();
	const $this = $(self);
	const id = $this.data('id');
	const currentCompetences = JSON.parse($selectedCompetencesInput.val());
	const indexInJson = currentCompetences.indexOf(id);

	if (action === 'add')
		if (indexInJson === -1) {
			currentCompetences.push(id);
			$('html, body').animate({ scrollTop: 0 }, 'fast');
		}

	if (action === 'remove') {
		currentCompetences.splice(indexInJson, 1);
		$this.parents('.js-competence-box').addClass('anim-fade-out');
		$(`.js-add-competence[data-id=${id}]`)
			.parents('.col-lg-3')
			.removeClass('disabled');
	}

	if (action === 'shift-left' || action === 'shift-right') {
		currentCompetences.splice(indexInJson, 1);
		currentCompetences.splice(
			indexInJson + (action === 'shift-left' ? -1 : 1),
			0,
			id
		);
	}

	$selectedCompetencesInput.val(JSON.stringify(currentCompetences));

	rerenderCompetences(currentCompetences, action === 'remove');
	$.post('/profile/update_competences', {
		currentCompetences,
	});

	return currentCompetences;
};

$(document.body).on('click', '.js-competence-remove', function (e) {
	e.preventDefault();
	competenceAction(e, 'remove', this);
});

$(document.body).on('click', '.js-competence-shift-left', function (e) {
	e.preventDefault();
	competenceAction(e, 'shift-left', this);
});

$(document.body).on('click', '.js-competence-shift-right', function (e) {
	e.preventDefault();
	competenceAction(e, 'shift-right', this);
});

$(document.body).on('click', '.js-add-competence', function (e) {
	const currentCompetences = competenceAction(e, 'add', this);
	if (currentCompetences.length === 3 && !isDashboard)
		$('.js-add-competence').attr('disabled', true);

	$('.js-add-competence').attr('disabled', false);
	const $columnParent = $(this).parents('.col-lg-3');
	setTimeout(() => {
		$columnParent.addClass('disabled');
	}, 333);
});

if ($competenceBoxes.length > 0)
	rerenderCompetences(
		JSON.parse($selectedCompetencesInput.val()),
		isDashboard
	);
